module.exports = __webpack_public_path__ + "img/resultBg.373d27f5.png";